export const INIT_TVSCREEN = "INIT_TVSCREEN";
export const BET = "BET";
export const DRAW = "DRAW";
export const JACKPOT_UPDATE = "JACKPOT_UPDATE";
export const JACKPOT_HIT = "JACKPOT_HIT";
export const SET_LIFECYCLE_DATA = "SET_LIFECYCLE_DATA";
export const SET_LIFECYCLE_STATE = "SET_LIFECYCLE_STATE";
export const SET_LIFECYCLE_DRAW = "SET_LIFECYCLE_DRAW";
export const ADD_BET_IN_BETSLIP = "ADD_BET_IN_BETSLIP";
export const STATISTICS = "STATISTICS";
export const WINNINGPLAN = "WINNINGPLAN";
export const SET_TIPS_TO_CASHIER = "SET_TIPS_TO_CASHIER";
